module.exports = __webpack_public_path__ + "static/media/Road.2a9219c5.jpg";